import { render, staticRenderFns } from "./TasksView.vue?vue&type=template&id=7c1f7a71&scoped=true"
import script from "./TasksView.vue?vue&type=script&lang=js"
export * from "./TasksView.vue?vue&type=script&lang=js"
import style0 from "./TasksView.vue?vue&type=style&index=0&id=7c1f7a71&prod&lang=scss&scoped=true"
import style1 from "./TasksView.vue?vue&type=style&index=1&id=7c1f7a71&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c1f7a71",
  null
  
)

export default component.exports